import Splide from '@splidejs/splide';
import jQuery from 'jquery';

const carousel = {
    init: () => {
        
        let homepageSplide = document.querySelector('.header--homepage .splide');

        if ( homepageSplide ) {
            const homepageHeaderSplide = new Splide( '.header--homepage .splide', {
                type: 'loop',
                interval: 10000,
                speed: 1000,
                drag: false,
                arrows: false,
                autoplay: true,
                direction: 'ttb',
                height: '100vh',
                breakpoints: {
                    768: {
                        height: 800,
                        pagination: false,
                    }
                }
            } );
            
            jQuery('.is-active .splide-slide__content-container').css('transitionDuration', '0s');
            jQuery('.is-active .splide-slide__content-container').css('transform', 'translate3d(0, 100px, 0)');
            jQuery('.is-active .splide-slide__content-container').css('opacity', '0');
            jQuery('.is-active .splide-slide__content-container').css('transitionProperty', 'opacity, transform');
            
            homepageHeaderSplide.on( 'pagination:mounted', function ( data ) {
                const splidePagination = data.list.parentNode.querySelector( '.splide__pagination' );
                const splideActions = data.list.parentNode.querySelector( '.splide__actions' );
                const splideSocials = data.list.parentNode.querySelector( '.splide__socials' );
                splideActions.insertBefore( splidePagination, splideSocials );
                jQuery('.is-active .splide-slide__content-container').css('transitionDuration', '0.4s');
                jQuery('.is-active .splide-slide__content-container').css('transform', 'translate3d(0, 0, 0)');
                jQuery('.is-active .splide-slide__content-container').css('opacity', '1');
                jQuery('.is-active .splide-slide__content-container').css('transform', 'none');
            } );
    
            homepageHeaderSplide.mount();

            homepageHeaderSplide.on( 'move', function() {
                jQuery('.is-active .splide-slide__content-container').css('transitionDuration', '0s');
                jQuery('.is-active .splide-slide__content-container').css('transform', 'translate3d(0, 100px, 0)');
                jQuery('.is-active .splide-slide__content-container').css('opacity', '0');
                jQuery('.is-active .splide-slide__content-container').css('transitionProperty', 'opacity, transform');
            });

            homepageHeaderSplide.on( 'moved', function() {
                jQuery('.is-active .splide-slide__content-container').css('transitionDuration', '0.4s');
                jQuery('.is-active .splide-slide__content-container').css('transform', 'translate3d(0, 0, 0)');
                jQuery('.is-active .splide-slide__content-container').css('opacity', '1');
                jQuery('.is-active .splide-slide__content-container').css('transform', 'none');
            });
        }
    }
}

export default carousel;